module.exports = __webpack_public_path__ + "img/cb.b09bf9a7.jpg";